import {processTopicRef} from "../GuidelineNav/menuGeneration";

export const generateTablesAndFigures = (xmlString) => {
  const sanitizedXml = xmlString.replace(/\r?\n|\r/g, "");
  const xmlDoc = new DOMParser().parseFromString(sanitizedXml, "text/html");

  const tableNodes = xmlDoc.querySelectorAll('[class*="tnftable"]');
  const figureNodes = xmlDoc.querySelectorAll('[class*="tnffigure"]');

  return {tables: Array.from(tableNodes).map(node => processTopicRef(node)),
  figures: Array.from(figureNodes).map(node => processTopicRef(node))};
}

export const formatMenus = (title) => {
  const originalText = title?.replace(/\s+/g, " ").trim();
  const match = originalText?.match(
    /^(Figure|Table)\s+(\d+)(\.\d+)?(\s+)(.*)$/,
  );
  if (!match) return originalText;

  const figureLabel = `${match[1]} ${match[2] ?? ""}${match[3] ?? ""}`;
  const figureDescription = match[5];
  return { label: figureLabel, description: figureDescription };
};

